/* unplugin-vue-components disabled */import script from "./searchBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./searchBlock.vue?vue&type=script&setup=true&lang=js"

import "./searchBlock.vue?vue&type=style&index=0&id=37d68af7&lang=less&scoped=true"

import exportComponent from "/data/jenkins/workspace/infra_PayAdminWeb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37d68af7"]])

export default __exports__